import { BudgetRow, BudgetSummary } from './types';

export interface BudgetItem {
  category_id: string;
  category_name: string;
  sub_category_name: string;
  sub_category_id: string;
  amount: number;
  currency: string;
}

export interface Transaction {
  category_id: string;
  sub_category_id: string;
  amount: number;
  currency: string;
  type: string;
}

export function computeBudgetSummary(
  budgetItems: BudgetItem[],
  transactions: Transaction[]
): BudgetSummary {
  const expenseTransactions = transactions.filter((t) => t.type === 'expense');
  
  // TODO: compute budget and transactions of the same currency
  const rows: BudgetRow[] = budgetItems.map((item) => {
    const actual = expenseTransactions
      .filter((t) => t.category_id === item.category_id)
      .filter((t) => t.sub_category_id === item.sub_category_id)
      .reduce((sum, t) => sum + t.amount, 0);

    const budgeted = item.amount;
    const deviation = actual - budgeted;

    return {
      categoryId: item.category_id,
      categoryName: item.category_name,
      subCategoryId: item.sub_category_id,
      subCategoryName: item.sub_category_name,
      budgeted,
      actual,
      deviation,
      isOverBudget: actual > budgeted,
      currency: item.currency,
    };
  });

  const totalBudgeted = rows.reduce((sum, r) => sum + r.budgeted, 0);
  const totalActual = rows.reduce((sum, r) => sum + r.actual, 0);

  return {
    totalBudgeted,
    totalActual,
    totalDeviation: totalActual - totalBudgeted,
    rows,
  };
}
